import React, { useEffect, useState } from 'react';
import { Typography } from '../typography';
import { Button } from '../button';
import {
  ModalBase,
  ModalWrapper,
  ModalFooterButtons,
  ModalBodyCustomColumns,
} from './ModalComponents';
import { useBuyMarketplaceMutation, useIsSmallScreen } from '../../hooks';
import { enqueueSnackbar } from '../snackbar';
import { BorderLine } from '../border-line';
import { MESSAGES } from '../../const';
import { i18n } from '../../i18n';

interface MarketplaceBuyModalType {
  data: {
    id: string;
    number: string;
    price: number;
  }[];
  submitClick: () => void;
  open: () => void;
}

export const marketplaceBuyModal: MarketplaceBuyModalType = {
  data: [],
  submitClick: () => null,
  open: () => null,
};

export const MarketplaceBuyModal = () => {
  const { mutate } = useBuyMarketplaceMutation();
  const isSmallScreen = useIsSmallScreen();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    marketplaceBuyModal.open = () => {
      setOpen(true);
    };
  }, []);

  const handleOnClose = () => {
    marketplaceBuyModal.data = [];
    setOpen(!open);
  };

  const handleSubmitClick = async () => {
    mutate(
      marketplaceBuyModal.data.map((item) => ({
        id: item.id,
      })),
      {
        onSuccess: () => {
          setOpen(false);
          marketplaceBuyModal.submitClick();
        },
        onError: () => {
          enqueueSnackbar(MESSAGES.MARKETPLACE.ERROR.NOT_BUYED, 'error');
        },
      },
    );
  };

  return (
    <ModalBase
      id={'marketplace-buy-modal'}
      paperSize={isSmallScreen ? 'mobile' : 'default'}
      open={open}
      onClose={handleOnClose}
    >
      <ModalWrapper>
        <Typography variant={'textL'} weight={'bold'}>
          {i18n.t('pages.modal.marketplaceBuyTitle', { count: marketplaceBuyModal.data.length })}{' '}
          {marketplaceBuyModal.data.reduce((acc, item) => acc + Number(item.price), 0)}$
        </Typography>
        <ModalBodyCustomColumns columns={'1fr'}>
          {marketplaceBuyModal.data.map((item, i) => (
            <React.Fragment key={i}>
              {i !== 0 && <BorderLine space={'none'} />}
              <ModalBodyCustomColumns columns={'1fr max-content'}>
                <Typography variant={'textM'}>{item.number}</Typography>
                <Typography variant={'textM'}>{item.price}$</Typography>
              </ModalBodyCustomColumns>
            </React.Fragment>
          ))}
        </ModalBodyCustomColumns>
        <ModalFooterButtons>
          <Button size={'medium'} data-color={'white'} onClick={handleOnClose}>
            {i18n.t('button.cancel')}
          </Button>
          <Button size={'medium'} data-color={'primary'} onClick={handleSubmitClick}>
            {i18n.t('button.addToCart')}
          </Button>
        </ModalFooterButtons>
      </ModalWrapper>
    </ModalBase>
  );
};
